import React from 'react';
import s from './ConsentModal.module.css';

interface ConsentModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: string;
    renderContent: (content: string) => React.ReactNode;
}

export const ConsentModal: React.FC<ConsentModalProps> = ({
                                                              isOpen,
                                                              onClose,
                                                              content,
                                                              renderContent
                                                          }) => {
    if (!isOpen) return null;

    return (
        <div className={s.overlay} onClick={onClose}>
            <div className={s.modal} onClick={(e) => e.stopPropagation()}>
                <button className={s.closeButton} onClick={onClose}>×</button>
                <h3 className={s.subTitle}>Приложение № 1 к Политике конфиденциальности, размещенной на сайте https://rdb-method.ru/</h3>

                <h2 className={s.title}>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
                <div className={s.content}>
                    {renderContent(content)}
                </div>
            </div>
        </div>
    );
};